import { type CourseState } from '@editor2/types/courseState';

export const clearTempFieldsHelper = (state: CourseState) => {
	state.diffNodes = [];
	state.commits = [];
	state.tempInitCourse = null;
	state.tempCurrentCourse = null;

	return state;
};
